import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'input-data-option',
    templateUrl: 'input-data-option.component.html',
    styleUrls: ['input-data-option.component.scss']
})

export class InputDataOptionComponent implements OnInit {
    @Input()
    id: any;

    @Input()
    description: string;

    @Output()
    clicked = new EventEmitter<InputDataOption>();

    constructor() { }

    ngOnInit() { }
}

export class InputDataOption {
    id: any;
    description: string;
}
